import { Map } from 'immutable';
import { FormControl, IconButton, InputLabel, Button } from '@material-ui/core';
import AddIcon from '@mui/icons-material/Add';
import React from 'react';
import { Field, FieldArray } from 'redux-form/immutable';
import DeleteIcon from '@mui/icons-material/Delete';
import { FieldArrayFieldsProps, FieldArrayMetaProps } from 'redux-form';

import OrganizationApi from 'entities/organization/api';
import FormSelectBoxEntitySelector from 'retired/FormSelectBoxEntitySelector';
import FormTextField from 'retired/FormTextField';
import * as validators from 'utils/validators';
import { FormTagsInput } from 'retired/FormTagsInput/input';

const required = validators.required();

const RenderCapGroups = ({
  fields,
  meta: { error, submitFailed },
  currencySymbol,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fields: FieldArrayFieldsProps<any>;
  meta: FieldArrayMetaProps;
  // eslint-disable-next-line react/require-default-props
  currencySymbol?: string;
}): JSX.Element => (
  <div>
    <div style={{ marginBottom: 20 }}>
      <Button onClick={(): void => fields.push(new Map({ title: '' }))}>
        <AddIcon /> Add new user group limit
      </Button>
      {submitFailed && error && <span>{error}</span>}
    </div>
    {fields.map((capGroup: string, index: number) => (
      <div
        // eslint-disable-next-line react/no-array-index-key
        key={index}
        style={{
          border: '1px solid rgba(0, 0, 0, 0.2)',
          padding: 20,
          position: 'relative',
        }}
      >
        <div>
          <div
            style={{
              paddingRight: 10,
              position: 'absolute',
              top: 0,
              right: 0,
            }}
          >
            <IconButton title="Remove Cap Group" onClick={(): void => fields.remove(index)}>
              <DeleteIcon />
            </IconButton>
          </div>
        </div>
        <div style={{ flexGrow: 1 }}>
          <FormControl style={{ width: '100%', height: 17 }}>
            <InputLabel shrink>Group Title</InputLabel>
          </FormControl>
          <FormControl style={{ width: '100%' }}>
            <Field
              name={`${capGroup}.title`}
              component={FormTextField}
              placeholder="Cap Group Title"
              validate={required}
              required
            />
          </FormControl>

          <div style={{ marginTop: 30 }}>
            <FormControl style={{ width: '100%', height: 17 }}>
              <InputLabel shrink>Employee Roles</InputLabel>
            </FormControl>
            <Field
              name={`${capGroup}.criteria.jobTitle_in`}
              component={FormSelectBoxEntitySelector}
              fetchOptions={OrganizationApi.fetchJobTitles}
              placeholder="Select job title"
              showSearch
              allowClear
              multiple
            />
          </div>
          <div style={{ marginTop: 30 }}>
            <FormControl style={{ width: '100%', height: 17 }}>
              <InputLabel shrink>Functional Title</InputLabel>
            </FormControl>
            <Field
              name={`${capGroup}.criteria.additionalData-functionalTitle_in`}
              component={FormTagsInput}
            />
          </div>
          <div style={{ marginTop: 30 }}>
            <FormControl style={{ width: '100%', height: 17 }}>
              <InputLabel shrink>Organization Business Unit</InputLabel>
            </FormControl>
            <Field
              name={`${capGroup}.criteria.additionalData-organizationBusinessUnit_in`}
              component={FormTagsInput}
            />
          </div>
          <div style={{ marginTop: 30 }}>
            <FormControl style={{ width: '100%', height: 17 }}>
              <InputLabel shrink>Worker Type</InputLabel>
            </FormControl>
            <Field
              name={`${capGroup}.criteria.additionalData-workerType_in`}
              component={FormTagsInput}
            />
          </div>
          <div style={{ marginTop: 30 }}>
            <FormControl style={{ width: '100%', height: 17 }}>
              <InputLabel shrink>Officer</InputLabel>
            </FormControl>
            <Field
              name={`${capGroup}.criteria.additionalData-officer_in`}
              component={FormTagsInput}
            />
          </div>
          <div style={{ marginTop: 30 }}>
            <FormControl style={{ width: '100%', height: 17 }}>
              <InputLabel shrink>Custom Field 1</InputLabel>
            </FormControl>
            <Field
              name={`${capGroup}.criteria.additionalData-custom_field_1_in`}
              component={FormTagsInput}
            />
          </div>
          <div style={{ marginTop: 30 }}>
            <FormControl style={{ width: '100%', height: 17 }}>
              <InputLabel shrink>Limit Per User</InputLabel>
            </FormControl>
            {currencySymbol}
            <Field
              name={`${capGroup}.limitPerUser`}
              component={FormTextField}
              placeholder="Limit Per User"
              type="number"
              alwaysDisplayErrors
            />
          </div>
        </div>
      </div>
    ))}
  </div>
);

export const CapGroups = ({ currencySymbol }: { currencySymbol: string }): JSX.Element => (
  <FieldArray name="capGroups" component={RenderCapGroups} currencySymbol={currencySymbol} />
);
